import { useState } from 'react';

const HUMAN_LABELS = {
  unreviewed: 'Unreviewed',
  in_progress: 'In Progress',
  escalated: 'Escalated',
  pending_complete: 'Pending Complete',
  resolved: 'Resolved',
  no_action_needed: 'No Action Needed',
  // System statuses — shown when "include system" toggle is on, but never
  // selectable from the admin dropdown.
  skipped: 'Skipped',
  ai_error: 'Error',
  // Legacy / transient — kept for backward compat with any pre-migration rows.
  new: 'New',
  processed: 'Processed',
};

// Statuses an admin is allowed to set via the inline dropdown (matches the
// backend's PATCH whitelist). Order mirrors the workflow lifecycle;
// no_action_needed sits below a visual divider — it's a different kind
// of terminal state (never needed action, distinct from resolved).
const ADMIN_EDITABLE = [
  'unreviewed',
  'in_progress',
  'escalated',
  'pending_complete',
  'resolved',
];
const ADMIN_EDITABLE_TERMINAL = ['no_action_needed'];

export default function StatusBadge({ value, editable = false, onChange }) {
  const [busy, setBusy] = useState(false);

  if (!editable) {
    const cls = `status-badge status-badge--${value || 'new'}`;
    return <span className={cls}>{HUMAN_LABELS[value] || value || 'new'}</span>;
  }

  async function handleChange(e) {
    const next = e.target.value;
    if (next === value) return;
    try {
      setBusy(true);
      await onChange(next);
    } finally {
      setBusy(false);
    }
  }

  return (
    <select
      className="status-dropdown"
      value={value || 'new'}
      onChange={handleChange}
      disabled={busy}
      aria-label="Change status"
    >
      {ADMIN_EDITABLE.map((s) => (
        <option key={s} value={s}>
          {HUMAN_LABELS[s]}
        </option>
      ))}
      <option disabled>──────────</option>
      {ADMIN_EDITABLE_TERMINAL.map((s) => (
        <option key={s} value={s}>
          {HUMAN_LABELS[s]}
        </option>
      ))}
      {/* Render the current value as a non-actionable option if it's outside
          the admin-editable set (skipped / processed / ai_error). */}
      {value &&
        !ADMIN_EDITABLE.includes(value) &&
        !ADMIN_EDITABLE_TERMINAL.includes(value) && (
          <option value={value} disabled>
            {HUMAN_LABELS[value] || value}
          </option>
        )}
    </select>
  );
}
